/**
 * Engagement tracker — Spec 9.1 + S4.7
 *
 * Frontend olaylarını backend'e bildirir. Fire-and-forget, hata olursa sessizce yutar.
 */
import { api } from './api.js';

export type FrontendEngagementEvent =
  | 'report_viewed'
  | 'candidate_report_viewed'
  | 'team_report_viewed'
  | 'team_report_generated'
  | 'certificate_shared'
  | 'invite_link_copied'
  | 'calendly_clicked'
  | 'chatbot_engaged'
  | 'exam_invite_sent'
  | 'dashboard_visit';

export function trackEngagement(
  eventType: FrontendEngagementEvent,
  metadata?: Record<string, unknown>,
): void {
  // Fire-and-forget — engagement track UI'yi bloklamasın
  void api
    .post('/api/manager/engagement', { eventType, metadata })
    .catch(() => {
      /* silent */
    });
}
